import { defineMessages } from 'react-intl-next';

export default defineMessages({
	description: {
		id: 'project-pages.connect-space.not-connected.description',
		defaultMessage:
			'To use project pages, contact your admin or team lead to connect Confluence to this project.',
		description:
			'Page content when project pages is not connected to Confluence but the user does not have permission to connect it',
	},
	heading: {
		id: 'project-pages.connect-space.not-connected.heading',
		defaultMessage: 'Not connected to Confluence',
		description:
			'Page headding when project pages is not connected to Confluence but the user does not have permission to connect it',
	},
});
